import { NotebookKind } from '../../../../shared/types';

export const NOTEBOOK_KIND_PLACEHOLDER = `:notebookKind(${Object.values(NotebookKind).join('|')})`;
export const NOTEBOOK_PATH_PATTERN = `/notebook/${NOTEBOOK_KIND_PLACEHOLDER}/:notebookId`;
